const CASE_INVESTIGATION_MANAGER_CONSTANTS = {
  GETTING_CASE_INVESTIGATION_MANAGER_CONFIG: 'GETTING_CASE_INVESTIGATION_MANAGER_CONFIG',
  GET_CASE_INVESTIGATION_MANAGER_CONFIG_SUCCESS: 'GET_CASE_INVESTIGATION_MANAGER_CONFIG_SUCCESS',
  GET_CASE_INVESTIGATION_MANAGER_CONFIG_FAILURE: 'GET_CASE_INVESTIGATION_MANAGER_CONFIG_FAILURE',

  GETTING_CASE_INVESTIGATIONS: 'GETTING_CASE_INVESTIGATIONS',
  GET_CASE_INVESTIGATIONS_SUCCESS: 'GET_CASE_INVESTIGATIONS_SUCCESS',
  GET_CASE_INVESTIGATIONS_FAILURE: 'GET_CASE_INVESTIGATIONS_FAILURE',

  GETTING_CASE_INVESTIGATION_DETAILS: 'GETTING_CASE_INVESTIGATION_DETAILS',
  GET_CASE_INVESTIGATION_DETAILS_SUCCESS: 'GET_CASE_INVESTIGATION_DETAILS_SUCCESS',
  GET_CASE_INVESTIGATION_DETAILS_FAILURE: 'GET_CASE_INVESTIGATION_DETAILS_FAILURE',

  CREATING_NEW_CASE_INVESTIGATION: 'CREATING_NEW_CASE_INVESTIGATION',
  CREATE_NEW_CASE_INVESTIGATION_SUCCESS: 'CREATE_NEW_CASE_INVESTIGATION_SUCCESS',
  CREATE_NEW_CASE_INVESTIGATION_FAILURE: 'CREATE_NEW_CASE_INVESTIGATION_FAILURE',

  GETTING_FALCON_CASE_INVESTIGATIONS: 'GETTING_FALCON_CASE_INVESTIGATIONS',
  GET_FALCON_CASE_INVESTIGATIONS_SUCCESS: 'GET_FALCON_CASE_INVESTIGATIONS_SUCCESS',
  GET_FALCON_CASE_INVESTIGATIONS_FAILURE: 'GET_FALCON_CASE_INVESTIGATIONS_FAILURE',

  SET_CASE_INVESTIGATION_MANAGER_TO_INITIAL_STATE: 'SET_CASE_INVESTIGATION_MANAGER_TO_INITIAL_STATE'
};

export default CASE_INVESTIGATION_MANAGER_CONSTANTS;
